module.exports = __webpack_public_path__ + "static/Calluna-Semibold-webfont-bbef9715ed7ae1b34cd0856dd3387996.woff";